export const ADP_LAB_RESULTS_NS = 'components/AdpLabResults';

export const i18n = {
  en: {
    publishDate: 'Publish date',
    testResults: {
      columns: {
        characteristics: 'Characteristics',
        status: 'Status',
        units: 'Units',
        value: 'Value',
        limit: 'Limit type',
        isoStatedLimit: 'ISO stated limit',
      },
    },
  },
};
